module.exports = __webpack_public_path__ + "img/slide-14.f3a92a3d.png";